import { Select, Tag } from 'antd'
import {
  ELIGIBILITY_COLORS,
  ELIGIBILITY_LABELS,
  ELIGIBILITY_STATUS,
  type EligibilityStatus,
  eligibilityValues,
} from 'features/libra/types/eligibility'
import { Ban, Check, HelpCircle } from 'lucide-react'
import { FC, ReactNode, useMemo } from 'react'
import styled from 'styled-components'

const TAG_WIDTH = '100px'

const StyledTag = styled(Tag)`
  width: ${TAG_WIDTH};
  display: flex;
  align-items: center;
  gap: 0.25rem;
  justify-content: space-between;
`

const niiEligibilityLabels: Record<EligibilityStatus, () => ReactNode> = {
  [ELIGIBILITY_STATUS.ELIGIBLE]: () => (
    <StyledTag color={ELIGIBILITY_COLORS[ELIGIBILITY_STATUS.ELIGIBLE]}>
      <Check size={14} />
      <span>{ELIGIBILITY_LABELS[ELIGIBILITY_STATUS.ELIGIBLE]}</span>
    </StyledTag>
  ),
  [ELIGIBILITY_STATUS.NOT_ELIGIBLE]: () => (
    <StyledTag color={ELIGIBILITY_COLORS[ELIGIBILITY_STATUS.NOT_ELIGIBLE]}>
      <Ban size={14} />
      <span>{ELIGIBILITY_LABELS[ELIGIBILITY_STATUS.NOT_ELIGIBLE]}</span>
    </StyledTag>
  ),
  [ELIGIBILITY_STATUS.UNCLEAR]: () => (
    <StyledTag color={ELIGIBILITY_COLORS[ELIGIBILITY_STATUS.UNCLEAR]}>
      <HelpCircle size={14} />
      <span>{ELIGIBILITY_LABELS[ELIGIBILITY_STATUS.UNCLEAR]}</span>
    </StyledTag>
  ),
}

export const NiiEligibilitySelect: FC<{
  eligibility: EligibilityStatus | undefined
  setEligibility?: (value: EligibilityStatus) => void
  width?: string
}> = ({ eligibility, setEligibility, width = '150px' }) => {
  const options = useMemo(
    () =>
      eligibilityValues.map((e) => ({
        value: e,
        label: niiEligibilityLabels[e](),
      })),
    []
  )

  if (!setEligibility) {
    return eligibility ? niiEligibilityLabels[eligibility]() : <>-</>
  }

  return (
    <Select
      value={eligibility}
      onChange={setEligibility}
      style={{ width }}
      options={options}
    />
  )
}
